export default __webpack_public_path__ + "static/media/banner-12.3bf1dcd0.jpg";